import { render, staticRenderFns } from "./CategorySalesTables.vue?vue&type=template&id=c9e4a60e"
import script from "./CategorySalesTables.vue?vue&type=script&lang=js"
export * from "./CategorySalesTables.vue?vue&type=script&lang=js"
import style0 from "./CategorySalesTables.vue?vue&type=style&index=0&id=c9e4a60e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports